import ReducerRegistry from '../base/redux/ReducerRegistry';
import { REMOVE_SECOND_SCREEN, RESET_SECOND_SCREENS, SET_SECOND_SCREEN, SET_SECOND_SCREEN_WINDOW } from './actionTypes';
const DEFAULT_STATE = {
    screens: {}
};
ReducerRegistry.register('features/multi-screen', (state = DEFAULT_STATE, action) => {
    switch (action.type) {
        case SET_SECOND_SCREEN:
            // Merge so a re-configuration of an existing window keeps its live handle.
            return {
                ...state,
                screens: {
                    ...state.screens,
                    [action.id]: {
                        ...state.screens[action.id],
                        source: action.source,
                        // Keep the screen an existing window was configured for when
                        // the new request names none: re-sourcing a window (a
                        // setSecondScreen with no `screen`) says what it should show,
                        // not that it should go back to the default screen. Dropping
                        // it would also be read as "wherever a window with no screen
                        // goes" everywhere the id is used.
                        screenId: action.screenId ?? state.screens[action.id]?.screenId,
                        setAt: action.setAt
                    }
                }
            };
        case SET_SECOND_SCREEN_WINDOW: {
            const entry = state.screens[action.id];
            if (!entry) {
                return state;
            }
            return {
                ...state,
                screens: {
                    ...state.screens,
                    [action.id]: { ...entry, handle: action.handle }
                }
            };
        }
        case REMOVE_SECOND_SCREEN: {
            const screens = { ...state.screens };
            delete screens[action.id];
            return { ...state, screens };
        }
        case RESET_SECOND_SCREENS:
            return { ...state, screens: {} };
    }
    return state;
});
